(function () {
  // Store the original XMLHttpRequest
  const OriginalXMLHttpRequest = window.XMLHttpRequest;

  // Override XMLHttpRequest to intercept cart/add.js requests
  window.XMLHttpRequest = function () {
    const xhr = new OriginalXMLHttpRequest();
    const originalOpen = xhr.open;
    const originalSend = xhr.send;

    let isCartAddRequest = false;
    let requestUrl = "";
    let requestMethod = "";

    // Override open to capture URL and method
    xhr.open = function (method, url, async, user, password) {
      requestUrl = url;
      requestMethod = method.toUpperCase();
      isCartAddRequest =
        url.includes("/cart/add.js") || url.includes("cart_add_url");

      console.log("XHR Request:", method, url);

      return originalOpen.call(this, method, url, async, user, password);
    };

    // Override send to intercept cart add requests
    xhr.send = function (data) {
      if (isCartAddRequest && requestMethod === "POST") {
        console.log("Intercepting cart add request:", requestUrl, data);

        // Get cart element (drawer or notification)
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (cart) {
          console.log("cart", cart);
          let modifiedData = data;

          try {
            const bodyData = JSON.parse(data);
            console.log(`bodyData`, bodyData);
            const sections = cart
              .getSectionsToRender()
              .map((section) => section.id || section.section)
              .join(",");
            bodyData.sections = sections;
            bodyData.sections_url = window.location.pathname;
            modifiedData = JSON.stringify(bodyData);
            console.log(`modifiedData`, modifiedData);
            cart.setActiveElement &&
              cart.setActiveElement(document.activeElement);
          } catch (e) {
            console.warn("Could not parse request body for cart add:", e);
          }

          fetch(requestUrl, {
            ...fetchConfig("json"),
            body: modifiedData,
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("data", data);
              cart.renderContents(data);
            });
          return false;
          //return originalSend.call(this, modifiedData);
        } else {
          console.log("no cart found");
        }
      }

      // For non-cart requests or if no cart found, proceed normally
      return originalSend.call(this, data);
    };

    return xhr;
  };

  // Copy static properties and methods
  for (let prop in OriginalXMLHttpRequest) {
    if (OriginalXMLHttpRequest.hasOwnProperty(prop)) {
      window.XMLHttpRequest[prop] = OriginalXMLHttpRequest[prop];
    }
  }
})();
